import React, { useState } from "react";
import "./style.css";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
} from "antd";
import { values } from "pdf-lib";
import TextArea from "antd/es/input/TextArea";

const Index = () => {
  const [form] = Form.useForm();
  const [month, setMonth] = useState(false);
  const [year, setYear] = useState(false);
  const [presence, setPresence] = useState(false);
  const [records, setRecords] = useState(false);
  const [duration, setDuraion] = useState(false);
  const [days, setDays] = useState(false);
  const [hazards, setHazards] = useState(false);
  const [state, setState] = useState(false);

  const stateChanges = (e) => {
    if (e.target.value == "recordsProvided") {
      setState(true);
    } else {
      setState(false);
    }
  };

  const durationChanges = (e) => {
    if (e.target.value == "years") {
      setDuraion(true);
      setDays(false);
    } else if (e.target.value == "months") {
      setDays(true);
      setDuraion(false);
    } else {
      setDays(false);
      setDuraion(false);
    }
  };

  const onChangeTerm = (e) => {
    console.log(e.target.value);
    if (e.target.value == "month") {
      setMonth(e.target.value);
      setYear(false);
    } else if (e.target.value == "year") {
      setMonth(false);
      setYear(e.target.value);
    } else {
      setMonth(false);
      setYear(false);
    }
  };

  const onChangePaint = (e) => {
    if (e.target.value == "lead_Presence") {
      setPresence(true);
      setRecords(false);
    } else if (e.target.value == "records_Available") {
      setRecords(true);
      setPresence(false);
    } else {
      setRecords(false);
      setPresence(false);
    }
  };

  const HazardsChanges = (e) => {
    if (e.target.value == "lead_Hazards_Present") {
      setHazards(true);
    } else {
      setHazards(false);
    }
  };

  const onSubmit = async (values) => {
    console.log(values);
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/renantal-listing-agreement`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Rental Agreement"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  };
  return (
    <div className="main">
      <Form form={form} onFinish={onSubmit} autoComplete="off">
        <label>FINDERS FEE AGREEEMENT</label>
        <Row style={{ marginTop: "1rem" }}>
          <Col md={8}>
            <label>Date of Agreement(start)</label>
            <Form.Item
              name={"Agreement_Date_start"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Date of Agreement (end)</label>
            <Form.Item
              name={"Agreement_Date_end"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={8}>
            {" "}
            <label>Owner/Landlord Name</label>
            <Form.Item
              name={"Owner_Landlord_Name"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="Owner/Landlord Name" />
            </Form.Item>
          </Col>
        </Row>
        <label>Lease Term</label>
        <Row style={{ marginTop: "1rem" }}>
          <Col md={5}>
            <label>this month</label>
            <Form.Item
              name={"lease_term_month_this"}
              rules={[{ required: true, message: "required!" }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
          <Col md={5}>
            <label>of month</label>
            <Form.Item
              name="lease_term_month_of"
              rules={[{ required: true, message: "required!" }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>
        <hr />
        <label>Exclusive right to lease agreement</label>

        <div style={{ marginTop: "2rem" }}>
          <Row justify={"space-between"} gutter={8}>
            <Col md={8}>
              <label>landlord</label>
              <Form.Item
                name={"exclusinve_right_land_lord"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col md={12}>
              <label>property</label>
              <Form.Item
                name={"exclusinve_right_property"}
                rules={[{ required: true, message: "required!" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div style={{ marginTop: "2rem" }}>
          <label>Landlord duities and representation</label>
        </div>

        <Row style={{ marginTop: "1rem" }}>
          <Col md={5}>
            <Form.Item
              name={"landlord_duties"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                <Radio value={"do"}>Do</Radio>
                <Radio value={"do_not"}>Do not</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col md={8}>
            {" "}
            <Form.Item
              name={"landlord_duties_device"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                <Radio value={"audio"}>Audio</Radio>
                <Radio value={"video"}>Video</Radio>
                <Radio value={"audio&video"}>Both</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>

        <Row
          gutter={16}
          justify={"space-between"}
          style={{ marginTop: "1rem" }}
        >
          <Col md={8} style={{ marginTop: "2rem" }}>
            {" "}
            <label>Listing period</label>
          </Col>
          <Col md={8}>
            <label>Start</label>
            <Form.Item
              name={"listing_period_start"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>End</label>
            <Form.Item
              name={"listing_period_end"}
              rules={[{ required: true, message: "required!" }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
        <label>leasae/rental term</label>
        <div style={{ marginTop: "2rem" }}>
          <Row>
            <Col md={8}>
              <label>propery available on(for rent)</label>
              <Form.Item
                name={"propert_avaialbility_date_ForRent"}
                rules={[{ required: true, message: "required!" }]}
              >
                <DatePicker />
              </Form.Item>
            </Col>
            <Col md={8}>
              <label>Rental Duration (years or months)</label>
              <Form.Item
                name="property_available_duration"
                rules={[{ required: true, message: "required!" }]}
              >
                <Radio.Group onChange={durationChanges}>
                  <Radio value="years">Years</Radio>
                  <Radio value="months">Months</Radio>
                </Radio.Group>
              </Form.Item>

              {duration && (
                <div>
                  <label>Years</label>
                  <Form.Item
                    name="property_rent_years"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the number of years!",
                      },
                    ]}
                  >
                    <InputNumber />
                  </Form.Item>

                  <label>Fixed Term Lease</label>
                  <Form.Item
                    name="fixed_term_lease"
                    rules={[
                      {
                        required: true,
                        message: "Please select if it is a fixed term lease!",
                      },
                    ]}
                  >
                    <Radio.Group>
                      <Radio value="will">Will</Radio>
                      <Radio value="will_not">Will Not</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              )}

              {days && (
                <div>
                  <label>Months:</label>
                  <Form.Item
                    name="property_rent_months"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the number of months!",
                      },
                    ]}
                  >
                    <InputNumber />
                  </Form.Item>
                </div>
              )}
            </Col>
          </Row>
        </div>
        <div>
          <label>Lease/Rental price</label>
          <Form.Item
            name={"rental_price"}
            rules={[{ required: true, message: "required!" }]}
          >
            <Input placeholder="$" style={{ width: "50%" }} />
          </Form.Item>
        </div>
        <Row gutter={16} justify={"space-between"}>
          <Col md={8}>
            {" "}
            <label>Brokers duties fees</label>
            <Form.Item
              name={"broker_Fee_percentage"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="%" />
            </Form.Item>
          </Col>
          <Col md={8}>
            {" "}
            <label>Aforesaid fee (months)</label>
            <Form.Item
              name={"aforesaid_Fee_months"}
              rules={[{ required: true, message: "required!" }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
          <Col md={8}>
            <label>Broker reimbursement days</label>
            <Form.Item
              name={"broker_reimbursement_days"}
              rules={[{ required: true, message: "required!" }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>

        <label>Brooker Cooperation</label>

        <Row style={{ marginTop: "2rem" }}>
          <Col md={8} style={{ marginLeft: "2rem" }}>
            <label>Broker Agreement</label>
            <Form.Item
              name={"broker_agree"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group>
                <Radio value={"will"}>will</Radio>
                <Radio value={"will_not"}>will not</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col md={10}>
            <label>Cooperating licence</label>
            <Form.Item
              name={"brooker_coperation_cooperating_licence"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={"16"} justify={"space-between"}>
          <Col md={10}>
            <label>Subagents of seller</label>
            <Form.Item
              name={"brooker_coperation_Subagents_of_seller"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={10}>
            <label>Tenant agents</label>
            <Form.Item
              name={"brooker_coperation_tenants_agents"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <label>Extension/Renewal</label>

        <Row gutter={16} justify={"space-between"}>
          <Col md={8} style={{ marginLeft: "2rem" }}>
            <label>Broker Fee %</label>
            <Form.Item
              name={"broker_fee_perecentage"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="%" />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Extension renewal duration (select years)</label>
            <Form.Item
              name={"extension_renewal_duration"}
              rules={[{ required: true, message: "required!" }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
        </Row>

        <label>Sale</label>

        <Row gutter={16} justify={"space-between"}>
          <Col md={8} style={{ marginLeft: "2rem" }}>
            <label>Tenenant assign duration (select the years)"</label>
            <Form.Item
              name={"sale_tenant_years"}
              rules={[{ required: true, message: "required!" }]}
            >
              <InputNumber />
            </Form.Item>
          </Col>
          <Col md={12}>
            <label>Broker addition fee %</label>
            <Form.Item
              name={"broker_addition_fee_"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input placeholder="%" />
            </Form.Item>
          </Col>
        </Row>

        <label>Additional terms</label>
        <Form.Item
          name={"addition_terms"}
          rules={[{ required: true, message: "required!" }]}
        >
          <TextArea style={{ resize: "none" }} rows={4} />
        </Form.Item>
        <hr />

        <label>Tenant Certification Form</label>

        <Row
          gutter={16}
          justify={"space-between"}
          style={{ marginTop: "2rem" }}
        >
          <Col md={12}>
            <label>Owner's Disclosure</label>
            <Form.Item
              name={"Owner_Disclosure"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Radio.Group onChange={onChangePaint}>
                <Radio value={"lead_Presence"}>
                  Presence of Lead-Based Paint and/or Lead-Based Paint Hazards
                </Radio>
                <Radio value={"records_Available"}>
                  Records and Reports Available to the Owner/Lessor
                </Radio>
                {presence && (
                  <>
                    <div style={{ marginLeft: "1rem", marginTop: "2rem" }}>
                      {" "}
                      <Form.Item
                        rules={[{ required: true, message: "required!" }]}
                        name={"presence_detail"}
                      >
                        <Radio.Group onChange={HazardsChanges}>
                          <Radio value={"lead_Hazards_Present"}>
                            Lead-Based Paint Hazards Are Present in the Housing
                          </Radio>
                          <div style={{ marginLeft: "1rem" }}>
                            {hazards && (
                              <>
                                <Form.Item
                                  name="lead_Hazards_Present_detail"
                                  rules={[
                                    { required: true, message: "required!" },
                                  ]}
                                >
                                  <Input />
                                </Form.Item>
                              </>
                            )}
                          </div>
                          <Radio value={"no_Lead_Knowledge"}>
                            No Knowledge of Lead-Based Paint Hazards
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </>
                )}

                {records && (
                  <>
                    <div style={{ marginLeft: "1rem", marginTop: "2rem" }}>
                      {" "}
                      <Form.Item
                        name={
                          "records_and_reports_lead_based_paint_hazards_provided_tenant"
                        }
                        rules={[{ required: true, message: "required!" }]}
                      >
                        <Radio.Group onChange={stateChanges}>
                          <Radio value={"recordsProvided"}>
                            Owner/Lessor Has Provided All Available Records on
                            Lead-Based Paint Hazards
                          </Radio>
                          <Radio value={"noRecords"}>
                            Owner/Lessor Has No Reports or Records on Lead-Based
                            Paint Hazards
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                      <div style={{ marginLeft: "1rem" }}>
                        {state && (
                          <>
                            <Form.Item
                              name={"paint_hazards"}
                              rules={[{ required: true, message: "required!" }]}
                            >
                              <Radio.Group>
                                <Radio value={"lead_inspection"}>
                                  Lead Inspection Report
                                </Radio>
                                <Radio value={"risk_assesment"}>
                                  Risk Assessment Report
                                </Radio>
                                <Radio value={"letter_of_iterim"}>
                                  Letter of Interim Control
                                </Radio>
                                <Radio value={"letter_of_compliance"}>
                                  Letter of Compliance
                                </Radio>
                              </Radio.Group>
                            </Form.Item>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col md={10}>
            <label>
              Tenant Has Received Copies of All Documents Checked Above
            </label>
            <Form.Item
              name={"tenant_recived"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
            <label>Tenant Has Received No Documents Listed Above</label>
            <Form.Item
              name={"No_tenant_copies"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
            <label>
              Tenant has received the Massachusetts Tenant Lead Law Notification
            </label>
            <Form.Item
              name={"tenant_recieved_law"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
            <label>
              Agent Informed Owner/Lessor of Lead-Based Paint Disclosure
              Obligations
            </label>
            <Form.Item
              name={"tenant_informed_paint"}
              rules={[{ required: true, message: "required!" }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        <label>tenant reason</label>
        <Form.Item
          name={"tenant_reason"}
          rules={[{ required: true, message: "required!" }]}
        >
          <Input />
        </Form.Item>
        <label>property adress</label>
        <Form.Item name={"propert_address"}>
          <Input />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          submit
        </Button>
      </Form>
    </div>
  );
};

export default Index;
